import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PractiseBookPageActions } from '../practise/practise.actions';
import { catchError, exhaustMap, filter, map, of } from 'rxjs';
import { ApplicationFacade } from '@lyceo/shared/data-access';
import { BookService } from '../../book.service';
import { BookFacade } from './book.facade';
import { isDefined } from '@lyceo/shared/util';
import { BookActions } from './book.actions';
@Injectable()
export class BookEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly applicationFacade: ApplicationFacade =
    inject(ApplicationFacade);
  private readonly bookFacade: BookFacade = inject(BookFacade);
  private readonly bookService: BookService = inject(BookService);

  public bookLoaded$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PractiseBookPageActions.init),
      filter(() => !this.bookFacade.paramBookLoaded()),
      map(() => BookActions.getBook()),
    );
  });

  public getBook$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BookActions.getBook),
      map(() => this.bookFacade.paramBookId()),
      filter(isDefined),
      exhaustMap((bookId) =>
        this.bookService.getBook(bookId).pipe(
          map((book) =>
            BookActions.getBookSuccess({
              book: book,
            }),
          ),
          catchError((error: Error) =>
            of(BookActions.getBookFailure({ error })),
          ),
        ),
      ),
    );
  });

  public getBookFailure$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(BookActions.getBookFailure),
        map(() => {
          this.applicationFacade.showToaster({
            type: 'error',
            message: 'Het laden van het boek is niet gelukt.',
          });
        }),
      );
    },
    { dispatch: false },
  );
}
